jQuery(function ($) {
  const section = $('[data-comments]');
  const reply   = section.find('[data-reply]');
  const parentInput = section.find('input[name="comment_parent"]');

  reply.on('click', function () {
    parentInput.val($(this).data('reply'));
  });
});
